/** @file clip.delete: removes a clip from the puppet document. */
import type { CommandDef } from '../apply/commandDef';
import { clipInverse } from '../apply/clipInverse';
import { findClip } from '../puppetDoc/findClip';
import { readInput } from '../validate/readInput';

/** `clip.delete { clip }` → `{}`; inverse: `clip.import { doc: <the clip> }` (same name and id). */
export const clipDeleteCommand: CommandDef<'clip.delete'> = {
  name: 'clip.delete',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => ({ clip: readInput(input, path, ['clip']).str('clip') }),
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    const { name, clip } = findClip(draft, input.clip);
    const inverse = [clipInverse(clip, false)];
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- clips are keyed by name
    delete draft.clips[name];
    return { result: {}, warnings: [], inverse };
  },
};
